module.exports = __webpack_public_path__ + "static/img/CABECERA.75dc835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CABECERA.jpg
// module id = NDq1
// module chunks = 5